export const ADD_ITEMS = 'ADD_ITEMS';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const UPDATE_ITEMS = 'UPDATE_ITEMS';
export const GET_ITEMS = 'GET_ITEMS';
export const DELETE_ITEM = 'DELETE_ITEM';
export const ITEMS_LOADING = 'ITEMS_LOADING';
export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const NO_ITEMS = 'NO_ITEMS';